import { render } from "./guide-nearbyseo.vue?vue&type=template&id=6bb0576b"
import script from "./guide-nearbyseo.vue?vue&type=script&lang=js"
export * from "./guide-nearbyseo.vue?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__